import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { QueryKey } from "../../../consts/query-keys";

export const useBiomassAllocationData = (shouldFetchData: boolean) => {
  const { datasetId, id } = useParams();
  const { data: biomassAllocationData, isPending } = useQuery({
    queryKey: [QueryKey.BiomassAllocationSection],
    queryFn: () =>
      Plants.getBiomassAllocation({
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      }).then(response => {
        return response;
      }),
    throwOnError: true,
    enabled: shouldFetchData,
  });

  return { biomassAllocationData, isPending };
};
